import { Affix, Button, Card } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobileView } from "../../Common/AppHelper";
import Header from "../../Common/Header";
import AddPurchaseOrderForm from "./AddPurchaseOrderForm";

const AddPurchaseOrder = (props) => {
  // Props
  const { width } = props;

  // States
  const [poDetailsData, setPoDetailsData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Others
  const propertyFormRef = useRef(null);
  const navigate = useNavigate();

  const discartForm = () => {
    navigate("/merchandising/style-wise-quantity-breakdown");
  };

  const addPurchaseOrder = () => {
    if (isSubmitting) return;
    propertyFormRef.current.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add Style Wise Quantity Breakdown"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()} disabled={isSubmitting}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                loading={isSubmitting}
                disabled={isSubmitting}
                onClick={() => addPurchaseOrder()}
              >
                Add Style Wise Quantity Breakdown
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AddPurchaseOrderForm
        ref={propertyFormRef}
        poDetailsData={poDetailsData}
        setPoDetailsData={setPoDetailsData}
        mode={"add"}
        isSubmitting={isSubmitting}
        setIsSubmitting={setIsSubmitting}
      />
    </>
  );
};

export default AddPurchaseOrder;
